export default "<breadcrumbs [departmentId]='departmentId'></breadcrumbs>\n\n<router-outlet></router-outlet>"